import React, { Component } from "react";
import {
  Segment,
  Grid,
  Header,
  Button,
  Modal,
  Loader,
  Dimmer,
  Input,
  Message
} from "semantic-ui-react";


import fire from "../../config/config";

export default class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      tbc_address: "",
      btc_address: "",
      packages: [
        { val: "25" },
        { val: "50" },
        { val: "75" },
        { val: "100" },
        { val: "150" },
        { val: "200" },
        { val: "300" },
        { val: "400" },
        { val: "500" }
      ],
      open: false,
      opn: false,
      btcVal: "",
      pckge: "",
      proceedErr:
        "Please provide your BTC wallet addresse and make sure they are correct!",
      btcField: false,
      tbcField: false,
      checkoutId: "",
      userId: "",
      email: "",
      username: ""
    };
  }

  show(pckgVal, dimmer) {
    //first check if the guy is logged in
    //and then allow him to purchase
    this.setState({ loading: true });
    fire.auth().onAuthStateChanged(user => {
      if (user !== null) {
        fire
          .database()
          .ref("/users")
          .orderByChild("email")
          .equalTo(user.email)
          .on("value", snap => {
            let data = snap.val();
            //get the info from user
            let userId, username, email;
            for (let d in data) {
              userId = d;
              username = data[d].name;
              email = data[d].email;
            }
            //do the checkoutid computation
            let checkoutId = "";
            if (pckgVal == 50) {
              checkoutId = "c3b2d7e3-5fe7-46b2-a222-be5c1955c267";
              //"https://commerce.coinbase.com/checkout/56522b39-0666-4ab1-9e1e-53fd7d80b98f";
              //"https://commerce.coinbase.com/checkout/1cde2b87-459a-4cff-976b-ee90aae95717";
            } else if (pckgVal == 100) {
              checkoutId = "56522b39-0666-4ab1-9e1e-53fd7d80b98f";
              //"https://commerce.coinbase.com/checkout/68ac1231-6502-40ff-a9bd-71dc86a068ef";
            } else if (pckgVal == 150) {
              checkoutId = "33d39987-9984-406b-848d-c03c6c3ff69b";
            } else if (pckgVal == 200) {
              checkoutId = "97d54ec3-608c-4989-816c-4282b06ce416";
              //"https://commerce.coinbase.com/checkout/13eee091-5a9b-472b-8485-c93242259b97";
            } else {
              checkoutId = "5660e00e-a463-4e1d-9bf8-b039319746f5";
              //"https://commerce.coinbase.com/checkout/f2450694-b6bb-451d-9ca3-b77e5478899c";
            }
            //change the state
            this.setState({
              userId,
              username,
              email,
              loading: false,
              dimmer,
              open: true,
              pckge: pckgVal,
            });
          });
      } else {
        //just close the modal
        this.close();
      }
    });
  }

  close() {
    this.setState({
      open: false,
      btcField: false,
      btc_address: ""
    });
  }

  clos() {
    this.setState({
      opn: false,
    });
  }

  startPurchase(dim) {
    //if the user has started the buying process
    this.setState({ loading: true });
    let {
      pckge,
      btc_address,
      userId,
      email,
      username
    } = this.state;

    var time = new Date().getTime(); //purchase time

    fire
      .database()
      .ref("/packages/")
      .push({
        activated: false,
        email: email,
        purchasedBy: username,
        time: time,
        userId: userId,
        btc_address: btc_address,
        pckg: pckge
      })
      .then(() => {
        this.setState({ loading: false, dim, opn:true });
        //this.close();
      });
  }

  /*success(data) {
    //if the charge has succeeded
    this.setState({ loading: true });

    let {
      pckge,
      tbc_address,
      btc_address,
      userId,
      email,
      username
    } = this.state;

    var time = new Date().getTime(); //purchase time

    fire
      .database()
      .ref("/extraPackagesInfo/")
      .push({
        activated: false,
        email: email,
        purchasedBy: username,
        time: time,
        tbc_address: tbc_address,
        userId: userId,
        btc_address: btc_address,
        pckg: pckge,
        messageData: data,
        onChargeSuccess: true
      })
      .then(() => {
        this.setState({ loading: false });
        //this.close();
      });
  }*/

  /*detected(data) {
    //user payment has been detected
    this.setState({ loading: true });

    let {
      pckge,
      tbc_address,
      btc_address,
      userId,
      email,
      username
    } = this.state;

    var time = new Date().getTime(); //purchase time

    fire
      .database()
      .ref("/extraPackagesInfo/")
      .push({
        activated: false,
        email: email,
        purchasedBy: username,
        time: time,
        tbc_address: tbc_address,
        userId: userId,
        btc_address: btc_address,
        pckg: pckge,
        messageData: data,
        onPaymentDetected: true
      })
      .then(() => {
        this.setState({ loading: false });
        //this.close();
      });
  }*/

  render() {
    const {
      packages,
      open,
      dimmer,
      pckge,
      loading,
      proceedErr,
      btcField,
      opn,
      dim
    } = this.state;

    const {userName}= this.props
    //const timeNow = moment();
    return (
      <div>
        <Segment>
          <Grid>
            <Grid.Row style={{ padding: 40 }}>
              <div>
                <Header as="h3">Welcome <b>{userName}</b>!! Get Started! Choose your package.</Header>
              </div>
            </Grid.Row>
            <Grid.Row>
              <div>
                {packages.map((pckg, i) => (
                  <Button
                    onClick={() => this.show(pckg.val, "inverted")}
                    key={i}
                    icon="dollar"
                    size="massive"
                    style={{ margin: 20 }}
                    label={{
                      as: "a",
                      basic: true,
                      pointing: "right",
                      content: pckg.val
                    }}
                    labelPosition="left"
                  />
                ))}
              </div>
            </Grid.Row>

            <Modal dimmer={dimmer} open={open} onClose={() => this.close()}>
              <Modal.Header>Buy package</Modal.Header>
              <Modal.Content style={{ height: 450 }}>
                <Modal.Description>
                  <Header>Selected package: {pckge + "$"}</Header>
                  <p style={{ padding: 20, fontSize: 16 }}>
                    Each package is inclusive of 10% as admin fee for example
                    if one purchases a package of 27.5
                    your investment will be 25$ and 2.5$ as admin fee.
                    So you get 12.5$ as payment every after 15 days and
                    this will be paid   three times per investment totaling to
                    45 days, so this means 50% profit per package purchased.
                  </p>
                </Modal.Description>
                <Input
                  placeholder="Copy and paste your Bitcoin wallet address here"
                  required
                  style={{ width: 400, marginTop: 10 }}
                  onChange={(e, btc_address) => {
                    if (btc_address.value.replace(/\s/g, "") !== "") {
                      this.setState({
                        btc_address: btc_address.value,
                        btcField: true
                      });
                    }
                  }}
                />
                {proceedErr ? (
                  <Message color="red">{proceedErr}</Message>
                ) : null}
                {loading ? (
                  <Dimmer active inverted>
                    <Loader size="large">Loading</Loader>
                  </Dimmer>
                ) : null}
              </Modal.Content>
              <Modal.Actions>
                <Button
                  color="black"
                  style={{ float: "left" }}
                  onClick={() => this.close()}
                >
                  Cancel
                </Button>

                {btcField? (
                  <Button
                    color='blue'
                    onClick={()=>this.startPurchase("inverted")}
                  >
                    Buy With Crypto
                  </Button>
                ) : (
                  <Button disabled>Buy With Crypto</Button>
                )}
              </Modal.Actions>
            </Modal>

            <Modal dimmer={dim} open={opn} onClose={() => this.clos()}>
              <Modal.Content style={{ height: 450 }}>
                <Modal.Description>
                  <p style={{ padding: 25, fontSize: 20 }}>
                    To purchase the package send {pckge + "$"} worth of
                    Bitcoin to this address: XXXX-XXXX-XXXX-XXXX
                  </p>
                </Modal.Description>

              </Modal.Content>
              <Modal.Actions>
                <Button
                  color='black'
                  onClick={()=>this.clos()}>
                  Close
                </Button>
              </Modal.Actions>
            </Modal>
          </Grid>
        </Segment>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/UserDash/Main.js